import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post, postFormData } from ".";
import { systemAllRequests } from "../utilities/utils";

/**
 * Asynchronous function to fetch candidate documents.
 *
 * @param {Object} data - The data to be sent in the request
 * @return {Promise} A promise that resolves to the response from the post request
 */
export const _fetchCandidateDocuments = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.candidateDocuments,
    data: data,
  };
  return await post(request);
};

export const _updateBankCandidateDocuments = async (data) => {
  let formData = new FormData();
  formData.append("candidate_id", data.candidate_id);
  formData.append("compliance_id", data.compliance_id);
  formData.append("compliance_status", data.compliance_status);
  formData.append("not_applicable", data.not_applicable);
  formData.append("expirydate", data.expirydate);
  formData.append("compliance_file", data?.compliance_file);
  // extracompliance_file extracompliance_file1
  formData.append("extracompliance_file", data?.extracompliance_file);
  formData.append("extracompliance_file1", data?.extracompliance_file1);

  formData.append("extra_attachment_id", data?.extra_attachment_id);
  formData.append("extra_attachment_id1", data?.extra_attachment_id1);

  return postFormData(
    serviceRouteConstants?.editBankCandidateDocuments,
    formData,
  );
};

export const _fetchCandidateDetails = async (data) => {
  systemAllRequests({
    request: data,
    pageOfRequest: "candidate_detail",
    route: "get_candidate_details",
    method: "POST",
    page: "candidate_detail",
  });

  const request = {
    endPoint: serviceRouteConstants.candidateDetail,
    data: data,
  };
  return await post(request);
};

// resendComplianceNotificationToCandidate

export const _resendComplianceNotificationToCandidate = async (data) => {
  // console.log("data", data);
  // return;

  const request = {
    endPoint: serviceRouteConstants?.resendComplianceNotificationToCandidate,
    data: data,
  };
  return await post(request);
};

// export const _fetchCandidateCalendarShifts = async (data) => {
//   const request = {
//     endPoint: serviceRouteConstants.candidateCalendarShifts,
//     data: data,
//   };
//   return await post(request);
// }

export const _onOffOverRideComplianceForBankCandidate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.onOffOverRideComplianceForBankCandidate,
    data: data,
  };
  return await post(request);
};

// getCandidateComplianceUrl

export const _getCandidateComplianceUrl = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.getCandidateComplianceUrl,
    data: data,
  };
  return await post(request);
};
